import { render, staticRenderFns } from "./hotTopic.vue?vue&type=template&id=c1661c62&scoped=true"
import script from "./hotTopic.vue?vue&type=script&lang=js"
export * from "./hotTopic.vue?vue&type=script&lang=js"
import style0 from "./hotTopic.vue?vue&type=style&index=0&id=c1661c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1661c62",
  null
  
)

export default component.exports